export const paths = {
  Root: {
    children: {
      Analytics: {
        children: {
          Bluebooks: {
            dashboard: {
              children: {
                filter: ':startDate/:endDate/:status?',
              },
              path: 'bluebooks',
            },
            report: 'bluebooks/report/:clientAcronym/:startDate/:endDate/:status?',
          },
          Insights: 'insights',
          Models: 'models',
          Reports: {
            children: {
              CagingCalendar: {
                children: {
                  day: 'day/:year?/:month?/:day?',
                  month: 'month/:year?/:month?',
                  year: 'year/:year?',
                },
                path: 'caging-calendar',
              },
              ListPerformance: {
                children: {
                  filter: ':startDate/:endDate?',
                },
                path: 'list-performance',
              },
              ShippingLog: 'shipping-log',
            },
            path: 'reports',
          },
        },
        path: 'analytics',
      },
      AudienceBuilder: {
        children: {
          Build: {
            children: {
              add: {
                children: {
                  id: ':id',
                },
                path: 'add',
              },
              load: {
                children: {
                  id: ':id',
                },
                path: 'load',
              },
            },
            path: 'build',
          },
          Results: {
            children: {
              id: ':id',
            },
            path: 'results',
          },
        },
        Dashboard: 'dashboard',
        ExternalList: 'external-list',
        nlsOrders: 'nls-orders',
        path: 'audience-builder',
      },
      Dashboard: 'dashboard',
      Error: 'error',
      ForgotPassword: 'forgot-password',
      Integrations: {
        children: {
          Acxiom: 'axciom',
          Airtable: 'airtable',
          Intacct: 'intacct',
          L2: 'l2',
        },
        path: 'integrations',
      },
      Login: 'login',
      Logout: 'logout',
      NlsOrders: {
        nlsOrders: 'nls-orders',
      },
      NotFound: '404',
      Register: 'register',
      Security: {
        children: {
          Groups: 'groups',
          Users: 'users',
        },
        path: 'security',
      },
      User: {
        children: {
          ChangePassword: 'change-password',
          Profile: 'profile',
        },
        path: 'user',
      },
      Utilities: {
        children: {
          Caging: 'caging',
          Exceptions: 'exceptions',
          LRI: 'lri',
          PDF: 'pdf',
          Whitemail: 'whitemail',
        },
        path: 'utilities',
      },
      Workflow: {
        children: {
          CIS: 'cis',
          MergePurge: 'merge-purge',
          Studio: 'studio',
        },
        path: 'workflow',
      },
    },
    path: '/',
  },
} as const;
